<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :icon="icon"
    :sizeClass="sizeClass"
    :scrollable="scrollable"
    class="modal-p0 wizard-dialog"
    :showFooter="true"
    :showDelete="false"
    :showClose="false"
    :showSubmit="false"
    @closed="onClosed">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-bind:form="form" v-if="!loading && !loadingError">
      <FormWizard
        ref="modalWizard"
        :form="form"
        :submitting="submitting"
        :showFooter="false"
        :tabList="wizardTabList"
        @stepChange="stepChange">
        <template v-slot:content>
          <slot name="content" />
        </template>
      </FormWizard>
    </FormGroup>

    <template v-slot:rightFooterButtons>
      <FormButton class="btn-default" @click="closeClicked">Close</FormButton>
      <FormButton class="btn-primary" :disabled="!displayPrevious" @click="previousClicked">Previous</FormButton>
      <FormButton class="btn-primary" v-if="displayNext" @click="nextClicked">Next</FormButton>
      <FormButton class="btn-primary" v-if="displayFinish" :disabled="finishDisabled" :loading="submitting" @click="finishClicked">Create</FormButton>
    </template>
  </ModalDialog>  
</template>


<script>
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: 'WizardDialog',
  mixins: [
    ModalDialogMixin
  ],
  components: {
    ModalDialog
  },
  props: {
    title: String,
    icon: String,
    sizeClass: {
      type: String,
      default: "modal-xxl",
    },
    submitting: Boolean,
    scrollable: {
      type: Boolean,
      default: false,
    },
    loading: Boolean,
    loadingError: String,
    form: Object,
    wizardTabList: Array,
    finishDisabled: Boolean
  },
  data() {
    return {
      currentIndex: 0
    }
  },
  mounted() {
  },
  computed: {
    displayPrevious() {
      return this.currentIndex > 0
    },
    displayNext() {
      return (this.currentIndex < this.wizardTabList.length-1)
    },
    displayFinish() {
      return (this.currentIndex == this.wizardTabList.length-1)
    },
  },
  methods: {
    show(params) {

      return ModalDialogMixin.methods.show.call(this, params)
    },
    close(result) {
      this.modalClosed(result)
      this.hide()
    },
    onClosed(evt) {
      this.$emit('closed', evt)
    },
    closeClicked() {
      this.$emit('closed')
    },
    previousClicked(evt) {
      this.$refs.modalWizard.previousClicked()
    },
    nextClicked(evt) {
      this.$refs.modalWizard.nextClicked()
    },
    finishClicked(evt) {
      this.$emit('submitted', evt)
    },
    stepChange(index) {
      this.currentIndex = index
      this.$emit('stepChange', index)
    },
    selectTab(tabIndex) {
      if(this.$refs.modalWizard)
        this.$refs.modalWizard.selectTab(tabIndex)
    },
    clearWarningCounts() {
      if(this.$refs.modalWizard)
        this.$refs.modalWizard.clearWarningCounts()
    },
    setWarningCount(tabIndex, count) {
      if(this.$refs.modalWizard)
        this.$refs.modalWizard.setWarningCount(tabIndex, count)
    },
    clearResultCounts() {
      if(this.$refs.modalWizard)
        this.$refs.modalWizard.clearResultCounts()
    },
    setResultCount(tabIndex, count) {
      if(this.$refs.modalWizard)
        this.$refs.modalWizard.setResultCount(tabIndex, count)
    },
    displayErrors() {
      if(this.$refs.modalWizard)
        this.$refs.modalWizard.displayErrors()
    }
  }
}
</script>